export type Logger = {
  log: (...args: unknown[]) => void
}

export function createLogger(debug: boolean): Logger {
  return {
    log: (...args: unknown[]) => {
      if (!debug) {
        return
      }

      console.log('[Lenus Cookie Consent]', ...args)
    },
  }
}
